import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class BaseService {

  errorData: any;

  private errorStageMessage = new BehaviorSubject<any>({});
  currentErrorStageMessage = this.errorStageMessage.asObservable();

  setErrorData(errorData: any) {
    this.errorStageMessage.next(errorData);
  }

  constructor(private http: HttpClient,
    private router: Router) { }

  getData(url: string): Observable<any> {
    // this.spinner.show();
    return this.http.get<any>(url, { observe: 'response' });
  }

  getDataText(url: string): Observable<any> {
    // this.spinner.show();
    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
    // return this.http.get(url, { headers, responseType: 'text', observe: 'response' });
    return this.http.get(url, { headers, observe: 'response' });
  }

  getDataA(url: string): Observable<any> {
    // this.spinner.show();
    return this.http.get<any>(url).pipe(
      tap({
        next: x => {
          // this.spinner.hide();
          // console.log(x); 
        },
        error: err => {
          // this.spinner.hide(); 
          // console.error(err);
          if (err.error.message) {
            //  alert(err.error.message);
          } else if (err.message) {
            //    alert(err.message);
          }
        }
      })
    );
  }

  postData(reqObj: any, url: string): Observable<any> {
    // this.spinner.show();
    return this.http.post<any>(url, reqObj, { observe: 'response' }).pipe(
      tap({
        next: x => {
        },
        error: err => {
          if (err.error.message) {
          } else if (err.error.data) {
          }
        }
      })
    )
  }

  putData(reqObj: any, url: string): Observable<any> {
    return this.http.put<any>(url, reqObj, { observe: 'response' }).pipe(
      tap({
        next: x => {
        },
        error: err => {
          if (err.error.message) {
          } else if (err.error.data) {

          }
        }
      })
    );
  }

  patchData(reqObj: any, url: string): Observable<any> {
    return this.http.patch<any>(url, reqObj, { observe: 'response' }).pipe(
      tap({
        next: x => {
        },
        error: err => {
          if (err.error.message) {
          } else if (err.error.data) {
          }
        }
      })
    )
  }

  putDataForkJoinSkipIntercept(reqObj: any, url: string): Observable<any> {
    const headers = new HttpHeaders().set('Anonymous', '');
    return this.http.put<any>(url, reqObj, { headers, observe: 'response' }).pipe(
      tap({
        next: x => {
        },
        error: err => {
          if (err.error.message) {
          } else if (err.error.data) {

          }
        }
      })
    );
  }

  putDataForkJoinWithToken(reqObj: any, url: string): Observable<any> {
    const headers = new HttpHeaders().set('Anonymouswithtoken', '');
    return this.http.put<any>(url, reqObj, { headers, observe: 'response' }).pipe(
      tap({
        next: x => {
        },
        error: err => {
          if (err.error.message) {
          } else if (err.error.data) {

          }
        }
      })
    );
  }

  getDataForkJoinWithToken(url: string): Observable<any> {
    const headers = new HttpHeaders().set('Anonymouswithtoken', '');
    return this.http.get<any>(url, { headers, observe: 'response' });
  }

  getDataForkJoinSkipIntercept(url: string): Observable<any> {
    const headers = new HttpHeaders().set('Anonymous', '');
    return this.http.get<any>(url, { headers, observe: 'response' });
  }

  postDataForkJoinWithToken(reqObj: any, url: string): Observable<any> {
    const headers = new HttpHeaders().set('Anonymouswithtoken', '');
    return this.http.post<any>(url, reqObj, { headers, observe: 'response' }).pipe(
      tap({
        next: x => {
        },
        error: err => {
          if (err.error.message) {
          } else if (err.error.data) {

          }
        }
      })
    );
  }

  postDataWithoutAuth(url: string, reqObj: any): Observable<any> {
    // this.spinner.show();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post<any>(url, reqObj, httpOptions).pipe(
      tap({
        next: x => {
          // this.spinner.hide();
        },
        error: err => {
          // this.spinner.hide();
          console.error(err);
          if (err.error.message) {
            // alert(err.error.message);
          } else if (err.error.data) {
            console.log(err.error.data);
          }
        }
      })
    )
  }

  deleteRequest(url: string): Observable<any> {
    // const headers = new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
    // 'Content-Type': 'text/plain' });
    return this.http.delete<any>(url, { observe: 'response' }).pipe(
      tap({
        next: x => {
          // this.spinner.hide();
        },
        error: err => {
          // this.spinner.hide();
          console.error(err);
          if (err.error.message) {
            // alert(err.error.message);
          } else if (err.error.data) {
            console.log(err.error.data);
          }
        }
      })
    );
  }

  deleteRequestForkJoinWithToken(url: string): Observable<any> {
    const headers = new HttpHeaders().set('Anonymouswithtoken', '');
    return this.http.delete<any>(url, { observe: 'response' }).pipe(
      tap({
        next: x => {
          // this.spinner.hide();
        },
        error: err => {
          // this.spinner.hide();
          console.error(err);
          if (err.error.message) {
            // alert(err.error.message);
          } else if (err.error.data) {
            console.log(err.error.data);
          }
        }
      })
    );
  }

  deleteRequestA(reqObject: any, url: string): Observable<any> {
    const options: { headers: any; observe: any; body: any; } = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: reqObject,
      observe: 'response'
    }
    return this.http.delete<any>(url, options).pipe(
      tap({
        next: x => {
          // this.spinner.hide();
        },
        error: err => {
          // this.spinner.hide();
          console.error(err);
          if (err.error.message) {
            // alert(err.error.message);
          } else if (err.error.data) {
            console.log(err.error.data);
          }
        }
      })
    );
  }

  deleteRequestForkJoinWithTokenA(reqObject: any, url: string): Observable<any> {
    const options: { headers: any; observe: any; body: any; } = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Anonymouswithtoken': '' }),
      body: reqObject,
      observe: 'response'
    }
    return this.http.delete<any>(url, options).pipe(
      tap({
        next: x => {
          // this.spinner.hide();
        },
        error: err => {
          // this.spinner.hide();
          console.error(err);
          if (err.error.message) {
            // alert(err.error.message);
          } else if (err.error.data) {
            console.log(err.error.data);
          }
        }
      })
    );
  }

  postRequestWithFormData(contentType: any, reqObject: any, URL: any): Observable<any> {
    if (contentType) {
      const headers = new HttpHeaders({ 'Content-Type': contentType });
    }
    return this.http.post<Blob>(URL, reqObject, {
      withCredentials: true
    }).pipe(
      tap(data => {
        if (data) {
          // console.log('Error Message');
        } else {
          // console.log('Data at base', data);
        }
      }, error => {
        console.log('Error at base service post request with form data call', error);
      })
    );
  }

  postRequestForkJoinWithFormData(contentType: any, reqObject: any, URL: any): Observable<any> {
    let headers;
    console.log('contentType at base', contentType);
    if (contentType) {
      headers = new HttpHeaders({ 'Anonymouswithtoken': '', 'Content-Type': contentType });
    } else {
      headers = new HttpHeaders({ 'Anonymouswithtoken': '' });
    }
    return this.http.post<Blob>(URL, reqObject, {
      observe: 'response', headers
    }).pipe(
      tap(data => {
        if (data) {
          // console.log('Error Message');
        } else {
          // console.log('Data at base', data);
        }
      }, error => {
        console.log('Error at base service post request with form data call', error);
      })
    );
  }

  postRequestForkJoinWithFormDataSkipIntercept(reqObject: any, URL: any): Observable<any> {
    const headers = new HttpHeaders().set('Anonymous', '');
    return this.http.post<Blob>(URL, reqObject, {
      observe: 'response', headers
    }).pipe(
      tap(data => {
        if (data) {
          // console.log('Error Message');
        } else {
          // console.log('Data at base', data);
        }
      }, error => {
        console.log('Error at base service post request with form data call', error);
      })
    );
  }

  // open file with extension .url
  openUrlFile(urlFile: any) {
    const headers = new HttpHeaders().set('Anonymous', '');
    this.http.get(urlFile.download_url, {
      responseType: 'blob', headers
    })
      .subscribe((blob: any) => {
        // console.log('content', blob);
        this.extractUrlFromBlob(blob);

      });
  }

  private extractUrlFromBlob(blob: Blob) {
    const reader = new FileReader();
    reader.onload = (event) => {
      const content = event.target?.result as string;
      const targetUrl = this.parseUrlFileContent(content);
      console.log('Extracted URL:', targetUrl);
      if (targetUrl) {
        window.open(targetUrl, '_blank');
      }
    };
    reader.readAsText(blob);
  }

  private parseUrlFileContent(content: string): string | null {
    // .url files usually look like:
    // [InternetShortcut]
    // URL=https://www.example.com

    const lines = content.split('\n');
    const urlLine = lines.find(line => line.trim().startsWith('URL='));

    if (urlLine) {
      return urlLine.split('=')[1].trim();
    }
    return null;
  }

  handleError(error: any) {
    console.log(error);
  }
}
